import SectionHeader from "../SectionHeader";
import Button from "../Button";
import { Slide } from "react-slideshow-image";
import { useNavigate } from "react-router-dom";

export default function TopCategories() {
  return (
    <>
      <SectionHeader>Top Categories</SectionHeader>
      <section className="max-w-5xl  mx-auto font-fontOne  text-text font-semibold mt-8">
        <Slide
          arrows={false}
          indicators={() => <div className="top-categories-indicator"></div>}
        >
          <div className="flex justify-between px-[7px]">
            <Circle
              img={require("../../assets/home/top-categories/img01.png")}
            />
            <Circle
              img={require("../../assets/home/top-categories/img02.png")}
            />
            <Circle
              img={require("../../assets/home/top-categories/img03.png")}
            />
            <Circle
              img={require("../../assets/home/top-categories/img04.png")}
            />
          </div>
          <div className="flex justify-between px-[7px]">
            <Circle
              img={require("../../assets/home/top-categories/img02.png")}
            />
            <Circle
              img={require("../../assets/home/top-categories/img01.png")}
            />
            <Circle
              img={require("../../assets/home/top-categories/img04.png")}
            />
            <Circle
              img={require("../../assets/home/top-categories/img03.png")}
            />
          </div>
        </Slide>
      </section>
    </>
  );
}

function Circle({ img }) {
  const navigate = useNavigate();
  return (
    <div className=" w-56 text-center group ">
      {/* circle */}
      <div className="relative group-hover:shadow-custom_harsh flex justify-center items-center rounded-full w-56 h-56 bg-[#F6F7FB] mb-6 transition-all ">
        <div className="absolute w-full h-full hidden items-end justify-center group-hover:flex">
          <Button
            className=" mb-6 py-1 px-[0.75rem] text-sm "
            color="green"
            onClick={() => navigate("product/456")}
          >
            View Shop
          </Button>
        </div>
        <img src={img} alt="" />
      </div>
      {/* text */}
      <h4 className=" text-lg">Mini LCU Chair</h4>
      <div className=" text-sm">$56.00</div>
    </div>
  );
}
